import { useEffect, useState, type ReactElement } from 'react';
import { useNavigate } from 'react-router';
import { fullforInnlogging, loggInn } from '../auth/oidc.js';
import { Knapp } from '../komponenter/Knapp.js';

/**
 * The OIDC redirect target.
 *
 * Completes the code exchange, then replaces the history entry so the callback
 * URL — which carries the authorization code — cannot be revisited with the
 * browser's back button.
 *
 * The exchange itself is guarded in `fullforInnlogging`: the code is single-use,
 * and this effect can legitimately run more than once.
 */
export function AuthTilbake(): ReactElement {
  const naviger = useNavigate();
  const [feil, settFeil] = useState<string | null>(null);

  useEffect(() => {
    let avbrutt = false;
    void fullforInnlogging()
      .then(() => {
        if (!avbrutt) void naviger('/', { replace: true });
      })
      .catch(() => {
        if (!avbrutt) settFeil('Innloggingen kunne ikke fullføres.');
      });
    return () => {
      avbrutt = true;
    };
  }, [naviger]);

  return (
    <main className="flex min-h-screen items-center justify-center px-6">
      {feil ? (
        <div className="max-w-md text-center">
          <p role="alert" className="text-sm text-negativ">
            {feil}
          </p>
          {/* A spent authorization code cannot be reused, so "try again" has to
              mean starting the login over — not reloading this page. */}
          <Knapp
            className="mt-4"
            onClick={() => {
              void loggInn();
            }}
          >
            Logg inn på nytt
          </Knapp>
        </div>
      ) : (
        <p role="status" className="text-sm text-tekst-dempet">
          Fullfører innlogging …
        </p>
      )}
    </main>
  );
}
